/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'

const useGTMDataLayer = () => {
  const pushToDataLayer = useCallback((event: any, data = {}) => {
    if (typeof window !== 'undefined' && window?.dataLayer) {
      window?.dataLayer.push({
        event,
        ...data,
      })
    }
  }, [])
  const pushPurchaseEvent = useCallback(
    (transactionId: any, value: any, items: any) => {
      if (typeof window !== 'undefined' && window?.dataLayer) {
        window.dataLayer.push({ ecommerce: null })
      }

      const numericValue =
        typeof value === 'number' ? value : parseFloat(value) || 0
      const formattedItems = Array.isArray(items)
        ? items.map((item: any) => ({
            item_id: String(item.item_id || item.code || ''),
            item_name: String(item.item_name || item.name || ''),
            discount:
              typeof item.discount === 'number'
                ? item.discount
                : parseFloat(item.discount) || 0,
            price:
              typeof item.price === 'number'
                ? item.price
                : parseFloat(item.price) || 0,
            quantity:
              typeof item.quantity === 'number'
                ? item.quantity
                : parseInt(item.quantity, 10) || 1,
          }))
        : []

      const ecommerceData = {
        transaction_id: String(transactionId || ''),
        value: numericValue,
        currency: 'VND',
        items: formattedItems,
      }

      pushToDataLayer('purchase', {
        ...ecommerceData,
        ecommerce: ecommerceData,
      })
    },
    [pushToDataLayer]
  )
  const pushAddToCartEvent = useCallback(
    (
      itemId: any,
      itemName: any,
      price: number,
      discount: number,
      quantity = 1,
      currency = 'VND'
    ) => {
      if (typeof window !== 'undefined' && window?.dataLayer) {
        window.dataLayer.push({ ecommerce: null })
      }

      const numericPrice =
        typeof price === 'number' ? price : parseFloat(price as any) || 0
      const numericDiscount =
        typeof discount === 'number'
          ? discount
          : parseFloat(discount as any) || 0
      const numericQuantity =
        typeof quantity === 'number'
          ? quantity
          : parseInt(quantity as any, 10) || 1
      const totalValue = numericPrice * numericQuantity

      const itemData = {
        item_id: String(itemId || ''),
        item_name: String(itemName || ''),
        discount: numericDiscount,
        price: numericPrice,
        quantity: numericQuantity,
      }

      const ecommerceData = {
        currency,
        value: totalValue,
        items: [itemData],
      }

      pushToDataLayer('add_to_cart', {
        ...ecommerceData,
        ecommerce: ecommerceData,
      })
    },
    [pushToDataLayer]
  )
  const pushCancelOrderEvent = useCallback(
    (orderId: any, value: any, currency = 'VND', reason: any) => {
      pushToDataLayer('cancel_order', {
        order_id: String(orderId || ''),
        value: typeof value === 'number' ? value : parseFloat(value) || 0,
        currency: currency,
        reason: reason,
      })
    },
    [pushToDataLayer]
  )

  const pushApplyVoucherEvent = useCallback(
    (voucherCode: any, discountValue: any, currency = 'VND') => {
      pushToDataLayer('apply_voucher', {
        voucher_code: String(voucherCode || ''),
        discount_value:
          typeof discountValue === 'number'
            ? discountValue
            : parseFloat(discountValue) || 0,
        currency: currency,
      })
    },
    [pushToDataLayer]
  )

  return {
    pushToDataLayer,
    pushPurchaseEvent,
    pushAddToCartEvent,
    pushCancelOrderEvent,
    pushApplyVoucherEvent,
  }
}

export default useGTMDataLayer
